import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  list: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  item: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 70,
    '&::before': {
      content: "''",
      flex: 1,
      padding: '3px 8px',
      [theme.breakpoints.down(450)]: {
        padding: 3,
      },
    },
  },
  separatorRoot: {
    display: 'flex',
    flex: 0,
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  dot: {
    position: 'relative',
    display: 'block',
    width: 14,
    height: 14,
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: 4,
    zIndex: 1,
  },
  border: {
    position: 'absolute',
    display: 'block',
    width: 'calc(50% - 7px)',
    height: 1,
    background: 'rgba(34, 64, 96, .2)',
  },
  borderLeft: {
    left: 0,
  },
  borderRight: {
    right: 0,
  },
  hidden: {
    display: 'none',
  },
  content: {
    flex: 1,
    padding: '6px 8px',
    [theme.breakpoints.down(450)]: {
      padding: 3,
    },
  },
  text: {
    fontSize: 13,
    color: 'rgba(34, 64, 96, .4)',
    [theme.breakpoints.down(375)]: {
      fontSize: 11,
    },
  },
  highlitedText: {
    color: theme.custom.darkBlue,
  },
  blue: {
    background: theme.custom.darkBlue,
    borderColor: theme.custom.darkBlue,
  },
  green: {
    background: '#fff',
    borderColor: theme.custom.accept,
  },
  red: {
    background: '#fff',
    borderColor: theme.custom.warning,
  },
}));
